import { render, staticRenderFns } from "./AuditLogPagination.vue?vue&type=template&id=657754ba&"
import script from "./AuditLogPagination.vue?vue&type=script&lang=js&"
export * from "./AuditLogPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports